module.exports = __webpack_public_path__ + "img/fondo-becas_03-3.e5fc74c5.jpg";